/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddOrderBillDiscountModel as DigiworkMaitreDPosDtoOrderAddOrderBillDiscountModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/add-order-bill-discount-model';

export interface AddOrderBillDiscount$Params {
      body?: DigiworkMaitreDPosDtoOrderAddOrderBillDiscountModel
}

export function addOrderBillDiscount(http: HttpClient, rootUrl: string, params?: AddOrderBillDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addOrderBillDiscount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addOrderBillDiscount.PATH = '/api/wtr/OrderBill/addorderbilldiscount';
